__webpack_require__.p = "https://static.eleduck.com/_next/";